import { DropDownBase } from './Base';
import { DropDownMenu } from './Menu';

export const DropDown = {
  Base: DropDownBase,
  Menu: DropDownMenu,
};
